document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.bp-section').forEach(function (section) {
    var viewport = section.querySelector('.bp-track-viewport');
    var track = section.querySelector('.bp-track');
    var prevBtn = section.querySelector('.bp-arrow-prev');
    var nextBtn = section.querySelector('.bp-arrow-next');
    var dotsWrap = section.querySelector('.bp-dots');
    if (!viewport || !track) return;

    var originalItems = Array.prototype.slice.call(track.children);
    var realCount = originalItems.length;
    if (realCount === 0) return;

    var loopEnabled = section.dataset.loop === 'true' && realCount > 1;
    var autoplayEnabled = section.dataset.autoplay === 'true';
    var autoplaySpeed = (parseFloat(section.dataset.autoplaySpeed) || 4) * 1000;

    var autoplayTimer = null;
    var resumeTimer = null;
    var isPointerDown = false;

    function itemWidth() {
      var item = track.children[0];
      var gap = parseFloat(getComputedStyle(track).gap) || 20;
      return item.getBoundingClientRect().width + gap;
    }

    function visibleCount() {
      return Math.max(1, Math.round(viewport.clientWidth / itemWidth()));
    }

    // ---- Infinite loop via cloned sets (prepend + append one full copy) ----
    var realSetWidth = 0;

    function setupLoop() {
      if (!loopEnabled) return;

      originalItems.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button, input').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        track.appendChild(clone);
      });
      originalItems.slice().reverse().forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button, input').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        track.insertBefore(clone, track.firstChild);
      });

      // After clones are in place, jump to the middle (real) copy without animation
      requestAnimationFrame(function () {
        realSetWidth = track.scrollWidth / 3;
        var prevBehavior = viewport.style.scrollBehavior;
        viewport.style.scrollBehavior = 'auto';
        viewport.scrollLeft = realSetWidth;
        viewport.style.scrollBehavior = prevBehavior;
      });
    }

    function maintainLoopPosition() {
      if (!loopEnabled || !realSetWidth) return;
      var sl = viewport.scrollLeft;
      if (sl < realSetWidth * 0.5) {
        var prevBehavior = viewport.style.scrollBehavior;
        viewport.style.scrollBehavior = 'auto';
        viewport.scrollLeft = sl + realSetWidth;
        viewport.style.scrollBehavior = prevBehavior;
      } else if (sl > realSetWidth * 1.5) {
        var prevBehavior2 = viewport.style.scrollBehavior;
        viewport.style.scrollBehavior = 'auto';
        viewport.scrollLeft = sl - realSetWidth;
        viewport.style.scrollBehavior = prevBehavior2;
      }
    }

    function pageCount() {
      return Math.max(1, Math.ceil(realCount / visibleCount()));
    }

    function currentPage() {
      var sl = viewport.scrollLeft;
      if (loopEnabled && realSetWidth) {
        sl = sl - realSetWidth;
        if (sl < 0) sl += realSetWidth;
      }
      var page = Math.round(sl / (itemWidth() * visibleCount())) % pageCount();
      if (page < 0) page += pageCount();
      return page;
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var pages = pageCount();
      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'bp-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function (idx) {
          return function () {
            var base = loopEnabled ? realSetWidth : 0;
            viewport.scrollTo({
              left: base + idx * itemWidth() * visibleCount(),
              behavior: 'smooth'
            });
          };
        }(i));
        dotsWrap.appendChild(dot);
      }
    }

    function updateActiveDot() {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.bp-dot');
      var active = currentPage();
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === active);
      });
    }

    function scrollByPage(direction) {
      viewport.scrollBy({
        left: direction * itemWidth() * visibleCount(),
        behavior: 'smooth'
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByPage(-1); restartAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByPage(1); restartAutoplay(); });

    var scrollTimeout;
    viewport.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        maintainLoopPosition();
        updateActiveDot();
      }, 80);
    });

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        if (loopEnabled) realSetWidth = track.scrollWidth / 3;
        buildDots();
        updateActiveDot();
      }, 150);
    });

    // ---- Autoplay ----
    function startAutoplay() {
      if (!autoplayEnabled) return;
      stopAutoplay();
      autoplayTimer = setInterval(function () {
        scrollByPage(1);
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function restartAutoplay() {
      if (!autoplayEnabled) return;
      stopAutoplay();
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(startAutoplay, 1200);
    }

    if (autoplayEnabled) {
      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('mouseleave', startAutoplay);
      viewport.addEventListener('pointerdown', function () { isPointerDown = true; stopAutoplay(); });
      viewport.addEventListener('pointerup', function () { isPointerDown = false; restartAutoplay(); });
      viewport.addEventListener('touchstart', stopAutoplay, { passive: true });
      viewport.addEventListener('touchend', restartAutoplay, { passive: true });
    }

    setupLoop();
    buildDots();
    updateActiveDot();
    if (autoplayEnabled) startAutoplay();
  });
});
